"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); } // +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var productRouter = {
  path: '/product',
  component: _layout.default,
  redirect: '/product/list',
  name: 'Product',
  meta: {
    title: '商品',
    icon: 'clipboard'
  },
  children: [{
    path: 'list',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/product/index'));
      });
    },
    name: 'ProductList',
    meta: {
      title: '商品列表',
      icon: ''
    }
  }, {
    path: 'cdkey',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/product/cdkey/index'));
      });
    },
    name: 'Cdkey',
    meta: {
      title: '卡密管理',
      icon: ''
    }
  }, {
    //id:卡密库id
    path: 'cdkey/creatCdkey/:id?/:name?',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/product/cdkey/creatCdkey'));
      });
    },
    name: 'creatCdkey',
    meta: {
      title: '卡密添加',
      noCache: true,
      activeMenu: "/product/cdkey"
    },
    hidden: true
  }, {
    path: 'classify',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/product/category/index'));
      });
    },
    name: 'ProductClassify',
    meta: {
      title: '商品分类',
      icon: ''
    }
  }, {
    path: 'attr',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/product/attr/index'));
      });
    },
    name: 'ProductAttr',
    meta: {
      title: '商品规格',
      icon: ''
    }
  }, {
    path: 'comment',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/product/comment/index'));
      });
    },
    name: 'ProductComment',
    meta: {
      title: '商品评论',
      icon: ''
    }
  }, {
    //id:商品id，isDisabled：是否能编辑(1不能，2能)，isCopy：是否是采集商品(1是，2不是),productType:商品类型
    path: 'list/creatProduct/:id?/:isDisabled/:isCopy/:productType?',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/product/creatProduct/index'));
      });
    },
    name: 'creatProduct',
    meta: {
      title: '商品添加',
      noCache: true,
      activeMenu: "/product/list"
    },
    hidden: true
  }, {
    path: 'guarantee/group',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/product/guarantee/index'));
      });
    },
    name: 'ProductGuarantee',
    meta: {
      title: '保障服务组合',
      icon: ''
    }
  }, {
    path: 'label',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/product/label/index'));
      });
    },
    name: 'ProductLabel',
    meta: {
      title: '商品标签',
      icon: ''
    }
  }, {
    path: 'back',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/product/back/index'));
      });
    },
    name: 'ProductBack',
    meta: {
      title: '商品退货规则',
      icon: ''
    }
  }, {
    path: 'limit',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/product/limit/index'));
      });
    },
    name: 'ProductLimit',
    meta: {
      title: '商品限购规则',
      icon: ''
    }
  }]
};
var _default = exports.default = productRouter;